/**
 * The last answer of a polled API, kept in this browser so a page can show it at once when it opens.
 *
 * Without it every screen starts empty (cameras look offline, boxes show no count) for the second or two
 * the first request takes over the VPN, and then jumps to the real state. With it the page opens on what it
 * showed last time and is corrected by the first live answer. Answers older than `maxAgeMs` are ignored.
 */
export function readLast<T>(key: string, maxAgeMs = 10 * 60 * 1000): T | null {
  try {
    const raw = localStorage.getItem(`last:${key}`);
    if (!raw) return null;
    const v = JSON.parse(raw);
    return v && Date.now() - v.t < maxAgeMs ? (v.d as T) : null;
  } catch {
    return null;
  }
}

export function saveLast(key: string, data: unknown): void {
  try {
    localStorage.setItem(`last:${key}`, JSON.stringify({ t: Date.now(), d: data }));
  } catch { /* storage full or not available: the page simply starts empty next time */ }
}
